import { __assign } from 'tslib';
import { EVENT_CATEGORIES } from './constants.js';
import { makeMainEvent } from './helpers.js';

var calculatorOnMountEvent = function (eventLabel, event) {
    return makeMainEvent(__assign({ eventCategory: EVENT_CATEGORIES.LOAN, eventAction: 'Показ лендинга', eventLabel: eventLabel }, event));
};
var calculatorOnParamChangeEvent = function (eventLabel, event) {
    return makeMainEvent(__assign({ eventCategory: EVENT_CATEGORIES.LOAN, eventAction: 'Изменение параметра', eventLabel: eventLabel }, event));
};
var calculatorOnParamErrorEvent = function (eventLabel, event) {
    return makeMainEvent(__assign({ eventCategory: EVENT_CATEGORIES.LOAN, eventAction: 'Ошибка заполнения поля', eventLabel: eventLabel }, event));
};
var calculatorGoToFormEvent = function (eventLabel, event) {
    return makeMainEvent(__assign({ eventCategory: EVENT_CATEGORIES.LOAN, eventAction: 'Переход к анкете', eventLabel: eventLabel }, event));
};
var buttonsClickEvent = function (eventLabel, event) {
    return makeMainEvent(__assign({ eventCategory: EVENT_CATEGORIES.LOAN, eventAction: 'Клик по кнопке лендинга', eventLabel: eventLabel }, event));
};
var authErrorEvent = function (eventLabel, event) {
    return makeMainEvent(__assign({ eventCategory: EVENT_CATEGORIES.LOAN, eventAction: 'Ошибка авторизации', eventLabel: eventLabel }, event));
};

export { authErrorEvent, buttonsClickEvent, calculatorGoToFormEvent, calculatorOnMountEvent, calculatorOnParamChangeEvent, calculatorOnParamErrorEvent };
//# sourceMappingURL=events.js.map
